import Icon from '../../Icon/Icon';

export default function ExpandToggle({
  expanded,
  onClick,
}: // children,
{
  expanded: boolean;
  onClick: (newState: boolean) => void;
  // children?: React.ReactNode;
}) {
  return (
    <div
      aria-hidden="true"
      onClick={() => {
        onClick(!expanded);
      }}
    >
      <Icon position="left" icon={expanded ? 'angleTop' : 'angleDown2'} size="sm" />
    </div>
    // <label className={styles.expandToggleContainer}>
    //   {expanded ? '▲' : '▼'}

    //   {children && <span>{children}</span>}

    //   <input
    //     type="checkbox"
    //     checked={expanded}
    //     onChange={() => onClick(!expanded)}
    //   />
    // </label>
  );
}
